import { Component, OnInit, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

const SEED_MIN = new Date(),
	SEED_MAX = new Date();
SEED_MIN.setHours(0,0);
SEED_MAX.setHours(23,59);

export interface TimePickerComponentParams {
	min?: Date;
	max?: Date;
	minuteIncrement?: number;
	value?: Date;
}


@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit, TimePickerComponentParams {

	@Input() min: Date = SEED_MIN;
	@Input() max: Date = SEED_MAX;
	@Input() minuteIncrement = 15;

	hour: number = 0;
	minute: number = 0;
	am: boolean;

	hours: number[] = [];
	minutes: number[] = [];
	
	@Input() set value(value: Date) {

		const d = value || new Date(),
			inc = this.minuteIncrement,
			min = d.getMinutes(),
			next = Math.ceil(min  / inc) * inc;
		if (next >= 59) {
			d.setMinutes(0);
		} else {
			d.setMinutes(next);
		}

		this.hour = d.getHours();
		this.minute = d.getMinutes();

	}
	get value() {
		const d = new Date();
		d.setHours(this.hour, this.minute, 0, 0);
		return d;
	}

	constructor(
		@Inject(MAT_DIALOG_DATA) private _data: TimePickerComponentParams
	) { }

	ngOnInit() {
		const d = this._data;
		if (d) {
			this.min = d.min || this.min;
			this.max = d.max || this.max;
			if (d.hasOwnProperty('minuteIncrement')) {
				this.minuteIncrement = d.minuteIncrement || 0;
			}
			if (d.hasOwnProperty('value')) {
				this.value = d.value;
			}
		}

		this._rekey();
	}

	private _rekey() {

		const hours = this.hours,
			minutes = this.minutes,
			min = this.min,	
			max = this.max,
			minHours = min.getHours(),
			maxHours = max.getHours(),
			inc = this.minuteIncrement;

		hours.length = 0;
		minutes.length = 0;

		for (let h = minHours; h <= maxHours; ++h) {
			hours.push(h);
		}
		for (let m = 0; m <= 59; m = m+= inc) {
			minutes.push(m);
		}
	}

	getSelected() {
		const d = new Date();
		d.setHours(this.hour, this.minute, 0, 0);
		return d;
	}

}
